import React, { useState } from "react";
import styled from "styled-components";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ButtonIcon from "../../styles/ButtonIcon";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import logo from "../../assets/wroot-logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ForestOutlinedIcon from "@mui/icons-material/ForestOutlined";
import { auth } from "../../authentication/firebase";
import UserAvatar from "../UserAvatar";

export default function MainNav() {
  const navigate = useNavigate();
  const mediaQueryLg = useMediaQuery("(min-width: 1180px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const uid = auth.currentUser?.uid;

  const navigationItems = [
    { text: "Home", path: "/", icon: <HomeOutlinedIcon /> },
    { text: "Products", path: "/cart", icon: <ShoppingCartOutlinedIcon /> },
    { text: "Projects", path: "/projects", icon: <ForestOutlinedIcon /> },
    { text: "About Us", path: "/about-us", icon: <InfoOutlinedIcon /> },
    { text: "Contact Us", path: "/contact-us", icon: <PhoneOutlinedIcon /> },
  ];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const drawer = (
    <StyledDrawer>
      <div className="drawer-header">
        <img
          src={logo}
          alt="wroot"
          onClick={() => {
            navigate("/");
            handleDrawerToggle();
          }}
        />
      </div>
      <List>
        {navigationItems.map((item) => (
          <ListItem
            button
            key={item.text}
            onClick={() => {
              navigate(item.path);
              handleDrawerToggle();
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <div className="drawer-footer">
        {uid ? (
          <UserAvatar onClick={handleDrawerToggle} />
        ) : (
          <button onClick={(e) => navigate("/signup")} className="primary-btn">
            Signup
          </button>
        )}
        <button
          onClick={() => {
            navigate("/subscribe");
            handleDrawerToggle();
          }}
          className="primary-btn"
        >
          Adopt your tree
        </button>
      </div>
    </StyledDrawer>
  );

  return (
    <>
      <StyledNavbar className="main-nav">
        <div className="navbar-container">
          <div onClick={() => navigate("/")} className="image-container">
            <img src={logo} alt="wroot" />
          </div>
          {mediaQueryLg ? (
            <>
              <div className="links">
                <NavLink
                  to="/"
                  style={({ isActive }) => {
                    return isActive
                      ? {
                          backgroundColor: "var(--primary-color)",
                        }
                      : {};
                  }}
                >
                  Home
                </NavLink>
                <NavLink
                  to="/cart"
                  style={({ isActive }) => {
                    return isActive
                      ? {
                          backgroundColor: "var(--primary-color)",
                        }
                      : {};
                  }}
                >
                  Products
                </NavLink>
                <NavLink
                  to="/projects"
                  style={({ isActive }) => {
                    return isActive
                      ? {
                          backgroundColor: "var(--primary-color)",
                        }
                      : {};
                  }}
                >
                  Projects
                </NavLink>
                <NavLink
                  to="/about-us"
                  style={({ isActive }) => {
                    return isActive
                      ? {
                          backgroundColor: "var(--primary-color)",
                        }
                      : {};
                  }}
                >
                  About Us
                </NavLink>
                <NavLink
                  to="/contact-us"
                  style={({ isActive }) => {
                    return isActive
                      ? {
                          backgroundColor: "var(--primary-color)",
                        }
                      : {};
                  }}
                >
                  Contact Us
                </NavLink>
              </div>
              <div className="btns">
                <button
                  onClick={() => navigate("/subscribe")}
                  className="primary-btn"
                >
                  Adopt your tree
                </button>
                {uid ? (
                  <ButtonIcon className="primary-btn">
                    <UserAvatar
                      onClick={(e) => navigate("/profile")}
                      showInfo={false}
                    />
                  </ButtonIcon>
                ) : (
                  <button
                    onClick={(e) => navigate("/signup")}
                    className="primary-btn"
                  >
                    Signup
                  </button>
                )}
              </div>
            </>
          ) : (
            <ButtonIcon onClick={handleDrawerToggle}>
              <MenuIcon />
            </ButtonIcon>
          )}
        </div>
      </StyledNavbar>
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
}

const StyledNavbar = styled.div`
  width: var(--section-width);
  margin: auto;
  z-index: 1000;
  /* background-color: #ffffff29;
  border: 1px solid #ffffff29; */
  h3 span {
    font-weight: inherit;
    font-size: inherit;
    color: var(--primary-color);
  }

  .navbar-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2rem;
    padding: 12px 20px;
    background-color: rgba(255, 255, 255, 0.47);
    box-shadow: 0 0 4px 1px rgba(131, 129, 129, 0.1);
    border-radius: 50px;
    overflow: hidden; // Ensures blur doesn't leak outside

    backdrop-filter: blur(70px);
    -webkit-backdrop-filter: blur(70px); // Important for Safari support

    background-color: rgba(
      255,
      255,
      255,
      0.4
    ); // Add a semi-transparent background to make the blur visible

    .links,
    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .links {
      /* gap: 2rem; */

      a {
        color: var(--text-color);
        padding: 6px 16px;
        border-radius: 50px;
        font-weight: 600;
      }
    }

    .btns {
      margin-left: auto;
    }

    .image-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      img {
        max-width: 100px;
        margin-right: 6px;
        height: auto;
      }
    }
  }

  @media (max-width: 520px) {
    h3 {
      display: none;
    }
  }
  @media (max-width: 1180px) {
    h3 {
      font-size: 1.8rem;
    }
    .navbar-container {
      justify-content: space-between;
      .links {
        display: none;
      }
    }
  }
`;

const StyledDrawer = styled.div`
  width: 280px;
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  .profile-container {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .drawer-header {
    padding: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;

    img {
      max-width: 140px;
      height: auto;
      cursor: pointer;
    }
  }

  .MuiListItemIcon-root {
    color: var(--text-light-color);
    cursor: pointer !important;
  }

  .MuiListItemText-primary {
    color: var(--text-color);
    font-weight: 500;
    cursor: pointer !important;
  }

  .drawer-footer {
    margin-top: auto;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    white-space: normal;

    button {
      width: 100%;
      padding: 0.8rem;
      border-radius: 50px;
      border: none;
      background: var(--primary-color);
      color: black;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        opacity: 0.9;
      }
    }
  }
`;
